import React, { useEffect, useRef, createRef } from 'react'
import gsap from 'gsap'

interface IProps {
  tabs: string[]
  activeTab: number
  onTabChange: (key: number) => void
}

export default function Tabs(props: IProps) {
  const { tabs, activeTab, onTabChange } = props

  const sliderRef = useRef<HTMLDivElement>(null)

  const tabRefs = tabs.map(() => createRef<HTMLButtonElement>())

  useEffect(() => {
    const activeBtn = tabRefs[activeTab].current
    const slider = sliderRef.current

    if (activeBtn && slider) {
      const bounds = activeBtn.getBoundingClientRect()
      const parentBounds = activeBtn.parentElement!.getBoundingClientRect()

      gsap.to(slider, {
        x: bounds.left - parentBounds.left,
        width: bounds.width,
        duration: 0.4,
        ease: 'power2.out',
      })
    }
  }, [activeTab])

  return (
    <div className="w-full bg-white bg-opacity-20 backdrop-filter-[30] rounded-lg backdrop-blur-md">
      <div className="relative flex bg-gray-200 rounded-full p-1">
        {/* Sliding indicator */}
        <div
          ref={sliderRef}
          className="absolute top-0 left-0 h-full bg-white rounded-lg shadow-md"
        />

        {tabs.map((tab, index) => (
          <button
            key={index}
            ref={tabRefs[index]}
            onClick={() => onTabChange(index)}
            className={`relative z-10 flex-1 text-center py-1 font-semibold transition-colors duration-300 ${
              activeTab === index ? 'text-black font-poppinsBold' : 'text-white'
            }`}
          >
            {tab}
          </button>
        ))}
      </div>
    </div>
  )
}
